export enum FeatureAuthorizationType {
  Base = 0,
  PageFeature = 0
}
